import React from 'react'

const AppLoading: React.FC = () => {
  return <h1>Loading</h1>
}

export default AppLoading
